define('drops/jitsiMeeting/jitsiMeeting',[
    'jquery',
    'when',
    'lq',
    'lq/drop',
    'lq/style'
], function ($, when, lq, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            meetingHasName: false
        }
    };

    function JitsiMeeting(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.meetingDataIsUpdated = false;
        self.isRendered = false;
        self.JitsiMeetExternalAPI = undefined;
        self.runningMeetingAPI = undefined;

        self.$meeting = $('<div />')
            .css({
                width: '100%',
                height: '100%',
                border: 0
            })
            .appendTo(self.$element);

        self.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap'
            });

        Style.renderStyles(self);

        return self;
    };

    Drop.extend(JitsiMeeting, Drop);

    JitsiMeeting.typeName = 'JitsiMeeting';

    JitsiMeeting.prototype.preRender = function () {
        var self = this;

        this.piping.visibility.apply(this);
        this.applyPosition();

        this.piping.datasources.registerDatasourceListener(
            this.data.meetingDatasource,
            function (data) {
                self.meetingData = data;
                self.meetingDataIsUpdated = true;
                self.tryStartMeeting();
            });

        var domain = self.data.jitsiServer || 'meet.jit.si';

        var deferred = when.defer();
        require(['https://' + domain + '/external_api.js'],
            function (jitsi) {
                deferred.resolve();

                self.JitsiMeetExternalAPI = jitsi;
                self.tryStartMeeting();
            });

        return deferred.promise;
    };

    JitsiMeeting.prototype.postRender = function () {
        var self = this;

        self.isRendered = true;
        self.tryStartMeeting();
    };

    JitsiMeeting.prototype.tryStartMeeting = function () {
        var self = this;

        if (!self.meetingDataIsUpdated) return;
        if (!self.isRendered) return;
        if (!self.JitsiMeetExternalAPI) return;

        self.meetingDataIsUpdated = false;

        if (window.cordova &&
            window.cordova.plugins &&
            window.cordova.plugins.diagnostic &&
            window.cordova.plugins.diagnostic.requestRuntimePermissions) {
            window.cordova.plugins.diagnostic.requestRuntimePermissions(function () {
                    self.startMeeting();
                },
                function (error) {
                    console.error("The following error occurred: " + error);
                },
                [
                    window.cordova.plugins.diagnostic.permission.CAMERA,
                    window.cordova.plugins.diagnostic.permission.RECORD_AUDIO
                ]);
        } else {
            self.startMeeting();
        }
    };

    JitsiMeeting.prototype.startMeeting = function () {
        var self = this;
        var meetingData = self.meetingData.Results[0];

        if (this.runningMeetingAPI)
            this.runningMeetingAPI.dispose();

        var domain = self.data.jitsiServer || 'meet.jit.si';
        var options = {
            roomName: 'LicquidMeeting-' + meetingData[self.data.meetingIdOutput],
            parentNode: self.$meeting[0],
            userInfo: {
                displayName: meetingData[self.data.fullNameOutput]
            },
            configOverwrite: {
                disableDeepLinking: true,
                disableInviteFunctions: true,
                doNotStoreRoom: true,
                //fileRecordingsEnabled: false,
                //fileRecordingsServiceEnabled: false,
                //fileRecordingsServiceSharingEnabled: false,
                //liveStreamingEnabled: false
            },
            interfaceConfigOverwrite: {
                //SHOW_JITSI_WATERMARK: false,
                //SHOW_WATERMARK_FOR_GUESTS: false
                SHOW_CHROME_EXTENSION_BANNER: false
            }
        };

        var api = new self.JitsiMeetExternalAPI(domain, options);

        self.runningMeetingAPI = api;

        if (self.data.meetingHasName) {
            api.executeCommand('subject', meetingData[self.data.meetingNameOutput]);
        }

        var avatarURL = meetingData[self.data.fullNameavaterURLOutputOutput];
        if (avatarURL) {
            api.executeCommand('avatarUrl', avatarURL);
        }

        api.addEventListener('readyToClose', function () {
            self.triggerEventIfEnabled('meetingEnded');
        });
    };

    return JitsiMeeting;
});
